import { NextPage } from "next"
import dynamic from "next/dynamic"
import Head from "next/head"
import React from "react"

import Footer from "~/components/organisms/Footer"

// NOTE: ↓のdynamicはssrせずspa(csr)で表示する
// see: https://nextjs.org/docs/advanced-features/dynamic-import#basic-usage
const AuthRegisterPage = dynamic(async () => import("~/components/pages/AuthRegisterPage"))

const Register: NextPage = () => {
  return (
    <>
      <Head>
        <title>新規登録フォーム | Infra（インフラ）</title>
      </Head>

      <AuthRegisterPage />
      <Footer />
    </>
  )
}

export default Register
